import { useEffect } from "react";

export const useDynamicTab = (title, favicon) => {
  useEffect(() => {
    if (title) document.title = title;

    if (favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = favicon;
    }
  }, [title, favicon]);
};
